import { render } from "./humanHome.vue?vue&type=template&id=1313397c&scoped=true"
import script from "./humanHome.vue?vue&type=script&lang=js"
export * from "./humanHome.vue?vue&type=script&lang=js"

import "./humanHome.vue?vue&type=style&index=0&id=1313397c&scoped=true&lang=css"

import exportComponent from "D:\\code\\humanbrainview\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1313397c"]])

export default __exports__